// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutSharedStyles } from "@tps/App/SharedStyles/CheckoutSharedStyles";
import { orderConfirmationPageContainerStyles } from "@tps/Overrides/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.headerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

orderConfirmationPageContainerStyles.wrapper = {
    css: css`
        ${checkoutSharedStyles.container?.css}
        margin-top: 16px;
    `,
};